import React, { useEffect, useState, useCallback } from 'react';
import client from '../api/client';
import toast from 'react-hot-toast';

const CACHE_COLUMNS = {
  horoscope: ['sign', 'period_type', 'lang', 'preview'],
  predictions: ['sign', 'date', 'language'],
  mood: ['date', 'language'],
  moon: ['date', 'language'],
  'moon-signs': ['date', 'sun_sign', 'lang', 'moon_phase', 'moon_sign', 'preview'],
};

export default function Caches() {
  const [activeTab, setActiveTab] = useState('horoscope');
  const [caches, setCaches] = useState([]);
  const [loading, setLoading] = useState(false);

  const tabs = ['horoscope', 'predictions', 'mood', 'moon', 'moon-signs'];

  const fetchCaches = useCallback(async () => {
    setLoading(true);
    try {
      const response = await client.get(`/api/v1/admin/caches/${activeTab}`);
      setCaches(response.data.data || []);
    } catch (error) {
      toast.error(`${activeTab} önbelleği yüklenemedi`);
      setCaches([]);
    } finally {
      setLoading(false);
    }
  }, [activeTab]);

  useEffect(() => {
    fetchCaches();
  }, [activeTab, fetchCaches]);

  const handleClearCache = async () => {
    if (!window.confirm(`${activeTab} önbelleğini temizlemek istiyor musunuz?`)) return;

    try {
      const response = await client.delete(`/api/v1/admin/caches/${activeTab}`);
      toast.success(`${activeTab} önbelleği temizlendi (${response.data.deleted_count} kayıt)`);
      fetchCaches();
    } catch (error) {
      toast.error('Önbellek temizlenemedi');
    }
  };

  const columns = CACHE_COLUMNS[activeTab] || [];

  return (
    <div>
      <h2 className="text-2xl font-bold text-white mb-6">🗃️ Önbellek Yönetimi</h2>

      {/* Tabs */}
      <div className="flex gap-2 mb-6">
        {tabs.map((tab) => (
          <button
            key={tab}
            onClick={() => setActiveTab(tab)}
            className={`px-4 py-2 rounded-lg transition capitalize text-sm ${
              activeTab === tab
                ? 'bg-indigo-500 text-white'
                : 'bg-slate-700 text-slate-300 hover:bg-slate-600'
            }`}
          >
            {tab}
          </button>
        ))}
      </div>

      {/* Info bar */}
      <div className="mb-6 flex items-center justify-between">
        <p className="text-slate-400 text-sm">{caches.length} kayıt</p>
        <button
          onClick={handleClearCache}
          disabled={caches.length === 0}
          className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition text-sm disabled:opacity-50"
        >
          {activeTab} Önbelleğini Temizle
        </button>
      </div>

      {/* Cache Table */}
      <div className="bg-slate-800 rounded-lg border border-slate-700 overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="bg-slate-700">
              <tr>
                <th className="px-6 py-3 text-left font-semibold text-slate-200">ID</th>
                {columns.map((col) => (
                  <th key={col} className="px-6 py-3 text-left font-semibold text-slate-200 capitalize">
                    {col.replace('_', ' ')}
                  </th>
                ))}
                <th className="px-6 py-3 text-left font-semibold text-slate-200">Oluşturulma</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan={columns.length + 2} className="px-6 py-8 text-center text-slate-400">
                    Yükleniyor...
                  </td>
                </tr>
              ) : caches.length === 0 ? (
                <tr>
                  <td colSpan={columns.length + 2} className="px-6 py-8 text-center text-slate-400">
                    Önbellek verisi bulunamadı
                  </td>
                </tr>
              ) : (
                caches.map((cache) => (
                  <tr key={cache.id} className="border-t border-slate-700 hover:bg-slate-750 text-slate-300">
                    <td className="px-6 py-3 font-mono text-xs">
                      {cache.id ? String(cache.id).slice(0, 8) + '...' : '-'}
                    </td>
                    {columns.map((col) => (
                      <td key={col} className="px-6 py-3 text-xs">
                        {cache[col] != null ? String(cache[col]) : '-'}
                      </td>
                    ))}
                    <td className="px-6 py-3 text-slate-400 text-xs whitespace-nowrap">
                      {cache.created_at || cache.generated_at || '-'}
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
